/* 
import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";

type SessionContextType = {
  sessionNo: number | null;
  projectNo: number | null;
  setSession: (sessionNo: number, projectNo: number) => void;
  clearSession: () => void;
};

const SessionContext = createContext<SessionContextType | undefined>(
  undefined
);

export const SessionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [sessionNo, setSessionNo] = useState<number | null>(() => {
    const value = sessionStorage.getItem("sessionNo");
    return value ? Number(value) : null;
  });

  const [projectNo, setProjectNo] = useState<number | null>(() => {
    const value = sessionStorage.getItem("activeProjectNo");
    return value ? Number(value) : null;
  });

  const setSession = (newSessionNo: number, newProjectNo: number) => {
    setSessionNo(newSessionNo);
    setProjectNo(newProjectNo);

    sessionStorage.setItem("sessionNo", String(newSessionNo));
    sessionStorage.setItem("activeProjectNo", String(newProjectNo));
  };

  const clearSession = () => {
    setSessionNo(null);
    setProjectNo(null);

    sessionStorage.removeItem("sessionNo");
    sessionStorage.removeItem("activeProjectNo");
  };

  return (
    <SessionContext.Provider
      value={{
        sessionNo,
        projectNo,
        setSession,
        clearSession,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = (): SessionContextType => {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error(
      "useSession must be used inside SessionProvider."
    );
  }

  return context;
};
 */

import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";

type SessionContextType = {
  sessionNo: number | null;
  projectNo: number | null;
  setSession: (sessionNo: number, projectNo: number) => void;
  clearSession: () => void;
};

const SessionContext = createContext<SessionContextType | undefined>(
  undefined
);

export const SessionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [sessionNo, setSessionNo] = useState<number | null>(() => {
    const value = sessionStorage.getItem("contractsSessionNo");
    return value ? Number(value) : null;
  });

  const [projectNo, setProjectNo] = useState<number | null>(() => {
    const value = sessionStorage.getItem("contractsProjectNo");
    return value ? Number(value) : null;
  });

  const setSession = (newSessionNo: number, newProjectNo: number) => {
    setSessionNo(newSessionNo);
    setProjectNo(newProjectNo);

    sessionStorage.setItem(
      "contractsSessionNo",
      String(newSessionNo)
    );

    sessionStorage.setItem(
      "contractsProjectNo",
      String(newProjectNo)
    );
  };

  const clearSession = () => {
    setSessionNo(null);
    setProjectNo(null);

    sessionStorage.removeItem("contractsSessionNo");
    sessionStorage.removeItem("contractsProjectNo");
  };

  return (
    <SessionContext.Provider
      value={{
        sessionNo,
        projectNo,
        setSession,
        clearSession,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = (): SessionContextType => {
  const context = useContext(SessionContext);

  if (!context) {
    throw new Error(
      "useSession must be used inside SessionProvider."
    );
  }

  return context;
};
